export default {
  time_options: {
    asap: {
      title: 'ASAP',
      description: 'Prêt en {{time}} min',
    },
    scheduled: {
      title: 'Planifier pour plus tard',
    },
  },
};
